import { ChangeDetectionStrategy, Component, OnDestroy, inject, signal } from '@angular/core';
import { UserSignalStore } from '@core/stores/user-signal-store.service';
import { SubSink } from 'subsink';
import { UserInterface } from '@core/interfaces/user.interface';
import { UserApiService } from '@core/services/api/user-api.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatTabGroup, MatTab } from '@angular/material/tabs';

import { UserFormComponent } from '../user-form/user-form.component';
import { TbsDialogComponent, TbsDialogHeaderComponent } from '@ngx-terabase/ui/dialog';
import { TbsTabsComponent } from '@ngx-terabase/ui/tabs';
import { TbsButtonDirective } from '@ngx-terabase/ui/button';
import { TbsCalloutComponent } from '@ngx-terabase/ui/callout';

@Component({
  selector: 'user-profile-dialog',
  templateUrl: './user-profile-dialog.component.html',
  styleUrls: ['./user-profile-dialog.component.scss'],
  imports: [
    TbsDialogComponent,
    TbsDialogHeaderComponent,
    CdkScrollable,
    MatDialogContent,
    TbsTabsComponent,
    MatTabGroup,
    MatTab,
    UserFormComponent,
    TbsButtonDirective,
    TbsCalloutComponent,
    MatDialogActions,
    MatDialogClose,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileDialogComponent implements OnDestroy {
  private userStore = inject(UserSignalStore);
  private userApiService = inject(UserApiService);

  public readonly user = signal<UserInterface>(this.userStore.user()!);
  public readonly submit = signal(false);
  public readonly formDirty = signal(false);
  public readonly resetPasswordStatus = signal<'success' | 'error' | 'loading' | undefined>(undefined);
  private subs = new SubSink();

  public submitDialog() {
    this.submit.set(true);
    this.formDirty.set(false);
  }

  public valueChanged(event: any) {
    this.formDirty.set(event);
    this.submit.set(false);
  }

  public resetPassword(): void {
    this.resetPasswordStatus.set('loading');
    this.subs.sink = this.userApiService.requestPasswordReset(this.user().email).subscribe({
      next: () => this.resetPasswordStatus.set('success'),
      error: () => this.resetPasswordStatus.set('error'),
    });
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
